import styled from "styled-components";

export const ErrorMessageContainer = styled.div`
  padding: 4rem 2rem;
`;
